var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgVictoryReactionsEnvyFill = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 306.64 306.64",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.32,0C68.78,0,0,68.78,0,153.32S68.78,306.64,153.32,306.64s153.32-68.78,153.32-153.32S237.86,0,153.32,0Z"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 63.33,
    y1: 105.62,
    x2: 120.29,
    y2: 105.62,
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "25.06999969482422px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 169.48,
    y1: 105.62,
    x2: 226.44,
    y2: 105.62,
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "25.06999969482422px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.67,
    y1: 215.36,
    x2: 180.66,
    y2: 215.36,
    style: {
      fill: "#fff",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 24
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.29,
    cy: 117.48,
    r: 12,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 24
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.44,
    cy: 117.48,
    r: 12,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 24
    }
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVictoryReactionsEnvyFill, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Victory_Reactions_EnvyFill.9f9a6ecb.svg";
export { ForwardRef as ReactComponent };